import {
  FETCH_METERS, FETCH_METERS_SUCCESS, FETCH_METERS_FAIL,
  FETCH_METER, FETCH_METER_SUCCESS, FETCH_METER_FAIL,
  CREATE_METER, CREATE_METER_SUCCESS, CREATE_METER_FAIL,
  UPDATE_METER, UPDATE_METER_SUCCESS, UPDATE_METER_FAIL,
  DELETE_METER, DELETE_METER_SUCCESS, DELETE_METER_FAIL,
  FETCH_METERS_BY_ASSET, FETCH_METERS_BY_ASSET_SUCCESS, FETCH_METERS_BY_ASSET_FAIL,
  FETCH_METER_READINGS, FETCH_METER_READINGS_SUCCESS, FETCH_METER_READINGS_FAIL,
  CREATE_METER_READING, CREATE_METER_READING_SUCCESS, CREATE_METER_READING_FAIL,
  FETCH_READINGS_BY_WORK_ORDER, FETCH_READINGS_BY_WORK_ORDER_SUCCESS, FETCH_READINGS_BY_WORK_ORDER_FAIL,
  CLEAR_METER_MESSAGES,
} from './actionTypes';

// Meters list
export const fetchMeters = (page, size, assetId, status, search) => ({
  type: FETCH_METERS, payload: { page, size, assetId, status, search }
});
export const fetchMetersSuccess = (data) => ({ type: FETCH_METERS_SUCCESS, payload: data });
export const fetchMetersFail = (error) => ({ type: FETCH_METERS_FAIL, payload: error });

// Single meter
export const fetchMeter = (id) => ({ type: FETCH_METER, payload: id });
export const fetchMeterSuccess = (meter) => ({ type: FETCH_METER_SUCCESS, payload: meter });
export const fetchMeterFail = (error) => ({ type: FETCH_METER_FAIL, payload: error });

// Create
export const createMeter = (data, callback) => ({ type: CREATE_METER, payload: { data, callback } });
export const createMeterSuccess = (meter) => ({ type: CREATE_METER_SUCCESS, payload: meter });
export const createMeterFail = (error) => ({ type: CREATE_METER_FAIL, payload: error });

// Update
export const updateMeter = (data, callback) => ({ type: UPDATE_METER, payload: { data, callback } });
export const updateMeterSuccess = (meter) => ({ type: UPDATE_METER_SUCCESS, payload: meter });
export const updateMeterFail = (error) => ({ type: UPDATE_METER_FAIL, payload: error });

// Delete
export const deleteMeter = (id, callback) => ({ type: DELETE_METER, payload: { id, callback } });
export const deleteMeterSuccess = (id) => ({ type: DELETE_METER_SUCCESS, payload: id });
export const deleteMeterFail = (error) => ({ type: DELETE_METER_FAIL, payload: error });

// Meters by asset
export const fetchMetersByAsset = (assetId) => ({ type: FETCH_METERS_BY_ASSET, payload: assetId });
export const fetchMetersByAssetSuccess = (meters) => ({ type: FETCH_METERS_BY_ASSET_SUCCESS, payload: meters });
export const fetchMetersByAssetFail = (error) => ({ type: FETCH_METERS_BY_ASSET_FAIL, payload: error });

// Readings
export const fetchMeterReadings = (meterId, page, size) => ({
  type: FETCH_METER_READINGS, payload: { meterId, page, size }
});
export const fetchMeterReadingsSuccess = (data) => ({ type: FETCH_METER_READINGS_SUCCESS, payload: data });
export const fetchMeterReadingsFail = (error) => ({ type: FETCH_METER_READINGS_FAIL, payload: error });

// Create reading
export const createMeterReading = (data, callback) => ({ type: CREATE_METER_READING, payload: { data, callback } });
export const createMeterReadingSuccess = (reading) => ({ type: CREATE_METER_READING_SUCCESS, payload: reading });
export const createMeterReadingFail = (error) => ({ type: CREATE_METER_READING_FAIL, payload: error });

// Readings by work order
export const fetchReadingsByWorkOrder = (workOrderId) => ({ type: FETCH_READINGS_BY_WORK_ORDER, payload: workOrderId });
export const fetchReadingsByWorkOrderSuccess = (readings) => ({ type: FETCH_READINGS_BY_WORK_ORDER_SUCCESS, payload: readings });
export const fetchReadingsByWorkOrderFail = (error) => ({ type: FETCH_READINGS_BY_WORK_ORDER_FAIL, payload: error });

// Clear
export const clearMeterMessages = () => ({ type: CLEAR_METER_MESSAGES });
